import React from "react";
import { ALL_CENTERS, CentersView } from "./Centers";

const INDIA_CENTERS = ALL_CENTERS.filter(
  (center) => center.country === "India",
);

function IndiaCenters() {
  return (
    <CentersView
      title="India Centers"
      subtitle="Centers in India"
      centers={INDIA_CENTERS}
      cityAsPanel
    />
  );
}

export default IndiaCenters;
